import { render, staticRenderFns } from "./addArticle.vue?vue&type=template&id=3270bdf3&"
import script from "./addArticle.vue?vue&type=script&lang=js&"
export * from "./addArticle.vue?vue&type=script&lang=js&"
import style0 from "./addArticle.vue?vue&type=style&index=0&id=3270bdf3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports